// Chakra imports
import { Flex, useColorModeValue } from '@chakra-ui/react';

// Custom components
import { HorizonLogo } from 'components/icons/Icons';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  const isCollapsed = mini === true && hovered === false;
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      minH={isCollapsed ? '8px' : 'auto'}
      mb={isCollapsed ? '4px' : '0px'}
    >
      {/* <HorizonLogo
        h="26px"
        w="175px"
        my="32px"
        color={logoColor}
        display={
          mini === false
            ? 'block'
            : mini === true && hovered === true
            ? 'block'
            : 'none'
        }
      /> */}
      {!isCollapsed ? <HSeparator mb="12px" /> : null}
    </Flex>
  );
}

export default SidebarBrand;
